import { images } from './images';

export const projects = [
  {
    id: 1,
    title: 'Commercial Complex',
    category: 'commercial',
    image: images.projects.project1,
    description: 'Modern commercial complex with innovative structural design',
    location: 'New York, USA'
  },
  {
    id: 2,
    title: 'Residential Tower',
    category: 'residential',
    image: images.projects.project2,
    description: 'Luxury residential tower with earthquake-resistant design',
    location: 'Los Angeles, USA'
  },
  {
    id: 3,
    title: 'Industrial Facility',
    category: 'industrial',
    image: images.projects.project3,
    description: 'State-of-the-art industrial facility with sustainable features',
    location: 'Chicago, USA'
  },
  {
    id: 4,
    title: 'Bridge Project',
    category: 'infrastructure',
    image: images.projects.project4,
    description: 'Iconic bridge design with advanced structural engineering',
    location: 'San Francisco, USA'
  }
]; 